
/**
 * Classe responsável em manter Usuário.
 */
export class UserDTO {

    usuario: string;
    nomeUsuario: string;
    email : string;

    constructor() { }
}